import { Injectable } from "@angular/core";
import { Router, ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { AuthService } from "../auth/auth.service";

@Injectable({
  providedIn: "root",
})
export class LoginGuardService  {
  constructor(private authService: AuthService, private route: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> | Promise<boolean> | boolean {
    // const token = route.queryParams["token"];
    // const user = route.queryParams["user"];
    // const projectId = route.queryParams["projectId"];
    // if (token) {
    //   this.authService.clearAll();
    //   this.authService.setToken(token);
    // }

    // if (user) {
    //   this.authService.setUserName(user);
    // }

    // if (projectId) {
    //   this.authService.setProjectId(projectId);
    // }

    // if (this.authService.isTokenExpired(token)) {
    //   this.route.navigate(["/session-expired"]);
    //   return false;
    // } else {
      return true;
    // }
  }
}
